import { useUBL } from '@common/log-manager';

export const useSizeInfoUBL = () => {
  const sendUBL = useUBL();

  const imageZoomClickUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'subtab_size_image',
      data: { catalog_product_id },
    });
  };

  const editRequestClickUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: 'correction_request',
      data: { catalog_product_id },
    });
  };

  const cropImageImpressionUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'banner',
      object_id: 'subtab_size_image',
      data: { catalog_product_id },
    });
  };

  const editRequestImpressionUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: 'correction_request',
      data: { catalog_product_id },
    });
  };

  const sizeInfoListImpressionUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'measurements',
      data: { catalog_product_id },
    });
  };

  const aiSizeImageImpressionUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_id: 'subtab_size_image',
      object_type: 'banner',
      data: { catalog_product_id },
    });
  };

  return {
    imageZoomClickUBL,
    editRequestClickUBL,
    cropImageImpressionUBL,
    editRequestImpressionUBL,
    sizeInfoListImpressionUBL,
    aiSizeImageImpressionUBL,
  };
};
